package com.jingfangpai.contentEntity.model

import com.jingfangpai.common.data.serializer.DateTimeSerializer
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.orm.mapping.enums.ContentConnectionEntityType
import com.jingfangpai.common.orm.mapping.enums.ContentConnectionRelationType
import kotlinx.serialization.Serializable

@Serializable
class ContentConnectionDto {
    var id:String? = null
    var contentId: String? = null
    var entityType: ContentConnectionEntityType? = null
    var entityId: String? = null
    var entityName: String? = null
    var relationType: ContentConnectionRelationType? = null
    var createdBy: String? = null
    @Serializable(with = DateTimeSerializer::class)
    var createdOn: DateTime? = null
    var isDeleted: Boolean = false
}